import axios from 'axios';

const voterRegistrationService = {
  async getElectionList() {
    const url = '/listElection';
    const response = await axios.get(url);
    if (response.data.status === 'ok') {
      return response.data;
    } else {
      throw new Error(response.data);
    }
  },
  emailRegister(data) {
    const url = '/emailRegister';
    return new Promise((resolve, reject) => {
      axios
        .post(url, data)
        .then(response => {
          resolve(response.data);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  emailResend(data) {
    const url = '/emailResend';
    return new Promise((resolve, reject) => {
      axios
        .post(url, data)
        .then(response => {
          resolve(response.data);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  emailValidate(data) {
    const url = '/emailValidate';
    return new Promise((resolve, reject) => {
      axios
        .post(url, data)
        .then(response => {
          resolve(response.data);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  completeRegistration(data) {
    const url = '/completeRegister';
    return new Promise((resolve, reject) => {
      axios
        .post(url, data)
        .then(response => {
          resolve(response.data);
        })
        .catch(error => {
          reject(error);
        });
    });
  }
};
export default voterRegistrationService;
